export default __webpack_public_path__ + "static/stains-6955ccb68c524c5c02c6039e8f79b46a.png";